import {
  SURVEY_CLASSIFICATION_KIND,
  SURVEY_CLASSIFICATION_ROLE,
  SurveyClassification,
} from '@ps/survey-utils';
import { Nullable } from '@ps/utils';

import { SurveyCreationCoreState } from '../../survey-creation-state.model';

const TRACKER_PARENT_CLASSIFICATION: SurveyClassification = {
  kind: SURVEY_CLASSIFICATION_KIND.TRACKER,
  role: SURVEY_CLASSIFICATION_ROLE.PARENT,
};

/**
 * Before any survey exists, a confirmed tracker config is the only signal that this workflow is a Tracker.
 */
export function resolvePreDraftKind(
  trackerConfig: SurveyCreationCoreState['trackerConfig'],
): Nullable<SurveyClassification> {
  return trackerConfig ? TRACKER_PARENT_CLASSIFICATION : null;
}
